import React from 'react';

//imgPerson
import imgPerson from "@images/common/person.png";

//react-redux
import { useSelector } from "react-redux";

function UserMessage(props) {
    const { value } = props && props;
    const listEngage = useSelector((state) => state?.listEngage?.data || {});
    return (
        <div className={`messengerCt__wrapper`}>
            <div className="messengerCt__message messengerCt__message--out">
                <div className="messengerCt__message-body">
                    <div className="messengerCt__message-content --arrow-right">
                        <div className="messengerCt__message-text whiteSpace-break" dangerouslySetInnerHTML={{ __html: value }} />
                    </div>
                </div>
                <div className="messengerCt__message-pic">
                    <img src={listEngage?.avatar_url || imgPerson} alt="avatar" />
                </div>
            </div>
        </div>
    );
};

export default UserMessage;